export const getReleaseStage = () => {
    if (process.env.NODE_ENV === 'development') {
        return 'local-dev';
    }
    if (window.location.host === 'stage.icsc.com') {
        return 'stage';
    }
    return 'production';
};

export const getCurrentEnvironment = getReleaseStage;
